import { defineStore } from 'pinia'
import tooManagement from '../api/tooManagement'

export const useJobAlertListStore = defineStore('jobAlertListStore', {
  state: () => ({
    isLoading: false,
    isDeletedSuccessfully: false,
    error: null,
    jobAlerts: [],
    filter: {
      email: null,
      siteId: null,
      companyIds: [],
      frequency: null,
      state: null,
      createdBefore: null,
      createdAfter: null,
      searchAreas: [
        {
          lat: null,
          lng: null,
          radiusKm: 10,
          label: '',
        },
      ],
      region: [],
      education: [],
      discipline: [],
      employmentType: [],
      workCategory: [],
      workExperience: [],
    },
    sortBy: 'id',
    sortOrder: 'desc',
    includeArchived: false,
    page: {
      number: 1,
      size: 10,
      totalElements: 0,
      totalPages: 0,
    },
  }),
  actions: {
    async load() {
      // Reset state
      this.jobAlerts = []
      this.error = null
      this.isDeletedSuccessfully = false

      this.isLoading = true
      try {
        const page = {
          page: this.page.number,
          size: this.page.size,
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
        }
        const filter = { ...this.filter }
        if (!filter.searchAreas[0].lat) {
          filter.searchAreas = []
        }
        const jobAlerts = await tooManagement.searchJobAlerts(filter, page)

        if (jobAlerts.meta.page.number === this.page.number) {
          this.jobAlerts = jobAlerts.data
          this.page = jobAlerts.meta.page
        }
      } catch (error) {
        this.error = error
      } finally {
        this.isLoading = false
      }
    },
    async loadAll() {
      const pageSize = 200
      const totalPages = Math.min(
        Math.ceil(10000 / pageSize), // We fetch 10000 items max
        Math.ceil(this.page.totalElements / pageSize), // Determine how many requests we need to fetch all the elements
      )

      const filter = { ...this.filter }
      if (!filter.searchAreas[0].lat) {
        filter.searchAreas = []
      }

      const pagePromises = []
      for (let i = 0; i < totalPages; i++) {
        pagePromises.push(
          tooManagement.searchJobAlerts(filter, {
            page: i + 1,
            size: pageSize,
            sortBy: this.sortBy,
            sortOrder: this.sortOrder,
          }),
        )
      }

      const alerts = []
      try {
        const results = await Promise.all(pagePromises)
        results.forEach((result) => {
          alerts.push(...result.data)
        })
        return alerts
      } catch (error) {
        this.error = error
      }
    },
    async removeJobAlerts(selected) {
      // Reset state
      this.isDeletedSuccessfully = false
      this.error = null

      const toRemove = []
      selected.forEach((value) => {
        toRemove.push(value)
      })
      try {
        await tooManagement.deleteJobAlerts({ value: toRemove })
        await this.load()
        this.isDeletedSuccessfully = true
      } catch (error) {
        this.error = error
      }
    },
  },
})
